import InsideSalesAcceptedModal from './InsideSalesAcceptedModal';

export default InsideSalesAcceptedModal;
